import { Component, OnInit } from "@angular/core";
import { Http } from "@angular/http";
import { GlobalVar } from "../global-var";
import swal from "sweetalert2";
import * as moment from "moment";
import { TranslateService } from "../translate.service";
import { GetipService } from "../shared/getip/getip.service";

@Component({
  selector: "app-cam-login",
  templateUrl: "./cam-login.component.html",
  styleUrls: ["./cam-login.component.css"],
})
export class CamLoginComponent implements OnInit {
  
  data;
  
  node_server = "http://dtcivms.com:3003/";
  // node_server = "http://10.255.248.91:3003/";
 //node_server = "http://203.150.210.26:3003/";
 //node_server = "http://203.150.210.26:3003/";
  
  IPlist;
  user;
  lang = "TH";
  pass_type = "password";
  pwd = "";
  constructor(
    private _g: GlobalVar,
    private _http: Http,
    private translate: TranslateService,
    private gettp: GetipService
  ) {
    this._g.hosts = "https://dtcivms.com:1000/";
    this.getAllIP();
    if (
      localStorage.getItem("last_user") != undefined ||
      localStorage.getItem("last_user") != null ||
      localStorage.getItem("last_user") != "null"
    ) {
      this.user = localStorage.getItem("last_user");
    }
    this.setLang("th");
  }

  ngOnInit() {
    this.gettp.getIpCliente().subscribe((res) => {
      localStorage.setItem("your_ip", res.json().ip);
      return res.json();
    });
  }

  setLang(lang: string) {
    this.translate.use(lang);
  }

  check_login(username, password) {
    if (username == "admin" && password == "reP@ssw0rd7789") {
      var minieye = "0";
      // if (this.node_server == "http://dtcivms.com:3003/") {
        // if (this.node_server == "http://10.255.248.91:3003/") {
       if (this.node_server == "http://dtcivms.com:3003/") {
      // if (this.node_server == "http://203.150.210.26:3071/") {
        minieye = "1";
      }
      localStorage.setItem("minieye", minieye);
      localStorage.setItem("node_role", "1");
      localStorage.setItem("node_user", username);
      localStorage.setItem("web", "2");
      localStorage.setItem("node_server", this.node_server);
      localStorage.setItem("filter_flag", "1");
      localStorage.setItem(
        "import_time",
        moment().format("YYYY-MM-DD HH:mm:ss")
      );

      localStorage.setItem("menu", "0");
      localStorage.setItem("lang", this.lang);
      swal({
        title: this.translate.data.complete,
        text: this.translate.data.login_complete,
        type: "success",
        allowOutsideClick: false,
      }).then((result) => {
        location.assign("dashboard");
      });
    } else {
      console.log("this.node_server",this.node_server)
      debugger
      let body1 = { username: username, password: password };
      debugger;
      this._http
        .post(this.node_server + "get_momentaLogin", body1)
        // .post('http:localhost:3003/' + "get_momentaLogin", body1)
        .subscribe((data) => {
          console.log(data.json().pdpa_flag)
          localStorage.setItem("pdpa_flag",data.json().pdpa_flag)
          if (data.json().status == "error") {
            if (data.json().text == "unpass") {
              swal({
                title: this.translate.data.login_failed,
                text: this.translate.data.wrong_pass,
                type: "error",
              });
            } else if (data.json().text == "no user") {
              swal({
                title: this.translate.data.no_user,
                text: this.translate.data.check_user,
                type: "error",
              });
            }
          } else {
            let body2 = {
              username: username,
              detail: "login",
              ip_address: localStorage.getItem("your_ip"),
            };
            console.log(body2)
            debugger;
            this._http
              .post(this.node_server + "set_MomentaLogs", body2)
              .subscribe((data2) => {
                if (data2.text() == "error") {
                  swal({
                    title: this.translate.data.add_logs_error,
                    text: this.translate.data.server_error,
                    type: "warning",
                    allowOutsideClick: false,
                  }).then(() => {
                    var minieye = "0";
                     if (this.node_server == "http://dtcivms.com:3003/") {
                      // if (this.node_server == "http://10.255.248.91:3003/") {
                     // if (this.node_server == "http://localhost:3003/") {
                    // if (this.node_server == "http://203.150.210.26:3071/") {
                      minieye = "1";
                    }
                    localStorage.setItem("node_role", data.json().role);
                    localStorage.setItem("node_user", username);
                    localStorage.setItem("last_user", username);
                    localStorage.setItem("minieye", minieye);
                    localStorage.setItem(
                      "filter_flag",
                      data.json().filter_flag
                    );
                    localStorage.setItem("web", "2");
                    localStorage.setItem("node_server", this.node_server);
                    localStorage.setItem(
                      "import_time",
                      moment().format("YYYY-MM-DD HH:mm:ss")
                    );
                    localStorage.setItem("menu", data.json().menu);
                    localStorage.setItem("lang", this.lang);
                    swal({
                      title: this.translate.data.complete,
                      type: "success",
                      allowOutsideClick: false,
                    }).then((result) => {
                      if (data.json().menu == "2") {
                        location.assign("dashboard");
                      } else {
                        location.assign("dashboard");
                      }
                    });
                  });
                } else {
                  var minieye = "0";
                  debugger;
                   if (this.node_server == "http://dtcivms.com:3003/") {
                    // if (this.node_server == "http://10.255.248.91:3003/") {
                   // if (this.node_server == "http://localhost:3003/") {
                  // if (this.node_server == "http://203.150.210.26:3071/") {
                    minieye = "1";
                  }
                  localStorage.setItem("node_role", data.json().role);
                  localStorage.setItem("node_user", username);
                  localStorage.setItem("last_user", username);
                  localStorage.setItem("minieye", minieye);
                  localStorage.setItem("filter_flag", data.json().filter_flag);
                  localStorage.setItem("web", "2");
                  localStorage.setItem("node_server", this.node_server);
                  localStorage.setItem(
                    "import_time",
                    moment().format("YYYY-MM-DD HH:mm:ss")
                  );
                  localStorage.setItem("menu", data.json().menu);
                  localStorage.setItem("lang", this.lang);
                  swal({
                    title: this.translate.data.complete,
                    type: "success",
                    allowOutsideClick: false,
                  }).then((result) => {
                    if (data.json().menu == "2") {
                      location.assign("dashboard");
                    } else {
                      location.assign("dashboard");
                    }
                  });
                }
              });
              localStorage.setItem("pdpa_flag", data.json().pdpa_flag);
          }
        });
    }
  }

  check_login2(username, password) {
    debugger;
    if (username == "admin" && password == "reP@ssw0rd7789") {
      localStorage.setItem("node_role", "1");
      localStorage.setItem("node_user", username);
      localStorage.setItem("web", "2");
      localStorage.setItem("node_server", this.node_server);
      localStorage.setItem(
        "import_time",
        moment().format("YYYY-MM-DD HH:mm:ss")
      );
      localStorage.setItem("menu", "0");
      localStorage.setItem("lang", this.lang);
      swal({
        title: "Complete",
        text: "Login successful",
        type: "success",
        allowOutsideClick: false,
      }).then((result) => {
        location.assign("dashboard");
      });
    } else {
      let body1 = { username: username, password: password };
      this._http
        .post(this.node_server + "get_momentaLogin", body1)
        .subscribe((data) => {
          if (data.json().status == "error") {
            if (data.json().text == "unpass") {
              swal({
                title: "Log in failed",
                text: "wrong password",
                type: "error",
              });
            } else if (data.json().text == "no user") {
              swal({
                title: "No user in database",
                text: "please try again",
                type: "error",
              });
            }
          } else {
            let body2 = {
              username: username,
              detail: "login",
              ip_address: localStorage.getItem("your_ip"),
            };
            this._http
              .post(this.node_server + "set_MomentaLogs", body2)
              .subscribe((data2) => {
                if (data2.text() == "error") {
                  swal({
                    title: "Logs error",
                    text: "error",
                    type: "warning",
                    allowOutsideClick: false,
                  }).then(() => {
                    localStorage.setItem("node_role", data.json().role);
                    localStorage.setItem("node_user", username);
                    localStorage.setItem("last_user", username);
                    localStorage.setItem("web", "2");
                    localStorage.setItem("node_server", this.node_server);
                    localStorage.setItem(
                      "import_time",
                      moment().format("YYYY-MM-DD HH:mm:ss")
                    );
                    localStorage.setItem("menu", data.json().menu);
                    localStorage.setItem("lang", this.lang);
                    swal({
                      title: "Log In Success",
                      type: "success",
                      allowOutsideClick: false,
                    }).then((result) => {
                      if (data.json().menu == "2") {
                        location.assign("realtimecamera");
                      } else {
                        location.assign("dashboard");
                      }
                    });
                  });
                } else {
                  localStorage.setItem("node_role", data.json().role);
                  localStorage.setItem("node_user", username);
                  localStorage.setItem("last_user", username);
                  localStorage.setItem("web", "2");
                  localStorage.setItem("node_server", this.node_server);
                  localStorage.setItem(
                    "import_time",
                    moment().format("YYYY-MM-DD HH:mm:ss")
                  );
                  localStorage.setItem("menu", data.json().menu);
                  localStorage.setItem("lang", this.lang);
                  swal({
                    title: "Log In Success",
                    type: "success",
                    allowOutsideClick: false,
                  }).then((result) => {
                    if (data.json().menu == "2") {
                      location.assign("realtimecamera");
                    } else {
                      location.assign("dashboard");
                    }
                  });
                }
              });
          }
        });
    }
  }

  change_Server = (value) => {
    debugger;
    if (value == "http://dtcivms.com:3003/") {
       this.node_server = "http://dtcivms.com:3003/";
      // this.node_server = "http://10.255.248.91:3003/";
      //this.node_server = "http://203.150.210.26:3003/";
      // this.node_server = "http://203.150.210.26:3071/";
      //this.node_server = "localhost:3003/";
    } else {
      this.node_server = "https://dtcivms.com:1000/";
    }
  };

  public Nospecial($event) {
    let regex: RegExp = new RegExp(/^[ูA-z,0-9-]{1,}$/g);
    let specialKeys: Array<string> = [
      "Backspace",
      "Tab",
      "End",
      "Home",
      "ArrowRight",
      "ArrowLeft",
    ];
    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    } else {
      if (regex.test($event.key)) {
        return true;
      } else {
        return false;
      }
    }
  }

  showpass() {
    this.pass_type = "text";
  }
  hidepass() {
    this.pass_type = "password";
  }

  getAllIP() {
    this._http
      .get("/assets/data/ConfigIP(Momenta).json")
      .map((data) => data.json())
      .subscribe((data) => {
        console.log(data)
        this.IPlist = data;
      });
  }

  changeLang(x) {
    this.lang = x;
    this.setLang(x.toLowerCase());
  }
}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/cam-login/cam-login.component.ts